import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const useGetJsonParams = () => {
  const location = useLocation();

  const [data, setData] = useState(
    Object.fromEntries(
      [...new URLSearchParams(location.search)].map(([k, v]) => [
        k,
        v === 'null' ? null : v === 'undefined' ? undefined : v,
      ]),
    ),
  );

  useEffect(() => {
    setData(
      Object.fromEntries(
        [...new URLSearchParams(location.search)].map(([k, v]) => [
          k,
          v === 'null' ? null : v === 'undefined' ? undefined : v,
        ]),
      ),
    );
  }, [location]);
  return data;
};

